<template>
    <div>
        <div class="mt-4 mb-8 space-y-2">
            <h2 class="text-3xl font-bold text-white">
                Reset your password
            </h2>
            <h3 class="text-sm text-gray-300">
                Enter your email address and we'll send you instructions on how to reset your password.
            </h3>
        </div>

        <form action="#" @submit.prevent="onSubmit">
            <div class="space-y-6">
                <UFormGroup label="Email address">
                    <UInput 
                        v-model="form.email" 
                        type="email" 
                        size="xl" 
                        required
                    />
                </UFormGroup>
            </div>

            <UButton block type="submit" size="xl" :loading="loading" color="black" class="mt-8">
                Reset Password
            </UButton>
        </form>

        <div class="mt-6 text-center">
            <UButton to="/login" variant="link" color="black">
                Back to login
            </UButton>
        </div>
    </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'auth', middleware: 'guest' })
useHead({ title: 'Reset Password' })

const loading = ref<boolean>(false)

const form = ref({
    email: '',
})

async function onSubmit() {
    loading.value = true

    try {
        await $fetch('/api/auth/password/forgot', {
            method: 'POST',
            body: form.value
        })

        navigateTo('/password/verify?email=' + form.value.email)
    } catch {} finally {
        loading.value = false
    }
}
</script>
